import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import MainLayout from "../../Layout/mainLayout";
// import { useNavigate } from "react-router-dom";
import { columnsFranchiseManager } from "../../Global Functions/columnsAntd";
import { getFranchiseManagerList, changeFranchiseManagerStatus } from "../../Redux/Actions/franchiseManagerAction";
import ListTopSearch from "../../Global Functions/listTopSearch";
import DateRangePopup from "../../Utils/dateFilterPopup";
import "./listFranchiseManager.css";
import toast from "react-hot-toast";

const ListFranchiseManager = () => {
    const dispatch = useDispatch();
    // const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });

    const { franchiseManagers, pagination: apiPagination, loading } = useSelector(
        (state) => state.franchiseManager || {}
    );

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(async (page, pageSize, showLoader = true) => {
        const payload = {
            page,
            limit: pageSize,
            role: "franchise manager",
            search: debouncedSearch,
            ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
            ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
        };
        try {
            await dispatch(getFranchiseManagerList(payload, showLoader));
            if (!showLoader) toast.success("List refreshed");
        } catch {
            if (showLoader) toast.error("Failed to fetch list");
        }
    }, [dispatch, debouncedSearch, dateRange]);

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize, fetchDetails]);

    useEffect(() => {
        if (apiPagination?.total !== undefined) {
            setPagination((prev) => ({ ...prev, total: apiPagination.total }));
        }
    }, [apiPagination]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, current: 1 }));
    }, [debouncedSearch]);

    const handleTableChange = (pagination) => setPagination(pagination);

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleStatusChange = useCallback(async (record, newStatus) => {
        if (record.status === newStatus) return;
        const payload = {
            id: record._id,
            status: newStatus,
        };
        try {
            await dispatch(changeFranchiseManagerStatus(payload));
        } catch {
            // toast already handled in the action
        }
    }, [dispatch]);

    // const handleViewManager = (record) => {
    //     navigate(`/franchise_manager/view/${record._id}`);
    // };

    const columns = useMemo(
        () => columnsFranchiseManager(handleStatusChange, canEdit),
        [handleStatusChange, canEdit]
    );

    return (
        <MainLayout>

            <div className="bookings_table">
                <div className="table_component_all">
                    <div style={{ gridColumn: "span 5", height: "auto" }}>
                        <ListTopSearch
                            h3heading="Franchise List"
                            setState={setSearchQuery}
                            buttonhead={canAdd ? "Add Franchise Master" : null}
                            navigateTo={canAdd ? "/franchise/add" : null}
                            onCalendarClick={() => setIsDatePopupVisible(true)}
                        />
                    </div>

                    <div className="custom_table">
                        <div style={{ padding: "0px 60px" }}>
                            <Table
                                dataSource={Array.isArray(franchiseManagers) ? franchiseManagers : []}
                                columns={columns}
                                pagination={pagination}
                                loading={loading}
                                onChange={handleTableChange}
                                scroll={{ x: 1900, y: 500 }}
                                rowKey="_id"
                                rowClassName={() => "text-center"}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />
        </MainLayout>
    );
};

export default ListFranchiseManager;